module.exports = __webpack_public_path__ + "img/banner.ad5c5c27.jpg";